import { Booking } from '../bookingsState';

const sortComparison = (booking1: Booking, booking2: Booking): number => {
    const date1 = booking1.legs[0].departureDate;
    const date2 = booking2.legs[0].departureDate;

    if (booking1.status !== 'Expired' && booking2.status === 'Expired') {
        return -1;
    } else if (booking1.status === 'Expired' && booking2.status !== 'Expired') {
        return 1;
    } else {
        if (date1.diff(date2) > 0) {
            return 1;
        }
        if (date1.diff(date2) < 0) {
            return -1;
        }
        return 0;
    }
};

export default sortComparison;
